import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslocoPipe],
    selector: 'app-role-permission-list',
    templateUrl: './role-permission-list.component.html',
})
export class RolePermissionListComponent {
    public readonly permissionLabels: InputSignal<string[]> = input.required<string[]>();
}
